import React, { useState } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import Dialog from '../../ui/Dialog';
import Carousel from '../../Carousel/Carousel.component';
import {
  partialUpdateCustomerInfo,
  uploadImage,
} from '../../../services/customer.service';
import { upload } from '../../../services/storage.service';

interface UpdateImageProps {
  data: {
    patient_id: string;
    imageURL: string | string[];
    program_id: string;
    imageDetails?: Array<{ dateUploaded?: string }>;
    isImageArray?: boolean;
    receipt_obj?: string;
  };
  title?: string;
  disabled?: boolean;
}

const UpdateImage = ({ data, title, disabled = false }: UpdateImageProps) => {
  const {
    patient_id,
    imageURL,
    program_id,
    imageDetails,
    isImageArray,
    receipt_obj,
  } = data;
  const [openModal, setOpenModal] = useState(false);
  const [newImage, setNewImage] = useState<File | null>(null);
  const [updatingImage, setUpdatingImage] = useState(false);

  console.log('patient_id', patient_id);
  console.log('receipt_obj', receipt_obj);

  const handleFullView = () => {
    const url = Array.isArray(imageURL) ? imageURL[0] : imageURL;
    const link = document.createElement('a');
    link.href = url;
    link.download = `${url.split('/').pop()}`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleReplaceImage = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];
      if (!file) {
        return;
      }
      console.log('file', file);
      setNewImage(file);
    };
    input.click();
  };

  const handleUploadImage = () => {
    setUpdatingImage(true);

    // return;
    uploadImage({ program_id, payload: { file: newImage as File } })
      .then((res) => {
        const imgUrl = res.result.url;
        partialUpdateCustomerInfo({
          program_id,
          customer_id: patient_id,
          payload: {
            metadata: {
              [receipt_obj]: [
                {
                  id: 'upload_receipt-1',
                  filepath: newImage?.name,
                  webview_path: imgUrl,
                },
              ],
            },
          },
        })
          .then((res) => {
            setOpenModal(false);
            setNewImage(null);
            alert('Image updated successfully');
            window.location.reload();
          })
          .catch((err) => {
            alert('Error updating image,'+err.message);
          });
      })
      .catch((err) => {
        alert('Error updating image,'+err.message);
      })
      .finally(() => {
        setUpdatingImage(false);
      });
  };

  const modalContent = (
    <div>
      {isImageArray ? (
        <div style={{ textAlign: 'center' }}>
          <Carousel images={imageURL as string[]} imageDetails={imageDetails} />
          <span style={{ display: 'inline-block' }}>
            Click particular image to enlarge
          </span>
        </div>
      ) : (
        <>
          {newImage ? (
            <img
              style={{
                objectFit: 'contain',
                height: '240px',
                width: '480px',
                margin: '0 auto',
                display: 'block',
              }}
              src={URL.createObjectURL(newImage)}
              alt=""
            />
          ) : (
            <img
              style={{
                objectFit: 'contain',
                height: '240px',
                width: '480px',
                margin: '0 auto',
                display: 'block',
              }}
              src={imageURL as string}
              alt=""
            />
          )}
          {imageDetails && imageDetails[0]?.dateUploaded ? (
            <div>Date Uploaded: {imageDetails[0].dateUploaded}</div>
          ) : null}
        </>
      )}
    </div>
  );

  const modalButtons = (
    <>
      <Button
        onClick={() => {
          setOpenModal(false);
          setNewImage(null);
        }}
        variant="contained"
      >
        Close
      </Button>
      {!isImageArray && newImage === null && (
        <Button onClick={handleFullView} variant="contained" color="secondary">
          Full View
        </Button>
      )}
      {!isImageArray && (
        <Button
          onClick={handleReplaceImage}
          variant="contained"
          color="secondary"
        >
          Select New Image
        </Button>
      )}
      {newImage && (
        <Button
          onClick={handleUploadImage}
          variant="contained"
          color="secondary"
          disabled={updatingImage}
        >
          {updatingImage ? (
            <CircularProgress size={20} style={{ marginRight: 5 }} />
          ) : null}
          {updatingImage ? 'Updating Image...' : 'Update Image'}
        </Button>
      )}
    </>
  );

  return (
    <>
      <Dialog
        open={openModal}
        title={title || 'Image'}
        content={modalContent}
        onSubmit={() => setOpenModal(false)}
        onClose={() => setOpenModal(false)}
      >
        {modalButtons}
      </Dialog>
      <Button
        disabled={disabled}
        color="secondary"
        variant="contained"
        size="small"
        onClick={() => setOpenModal(true)}
      >
        View Image
      </Button>
    </>
  );
};

export default UpdateImage;
